"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeatureBy = exports.getSelectedFeatures = exports.setFeatures = void 0;

var _join2 = _interopRequireDefault(require("lodash/fp/join"));

var _prop2 = _interopRequireDefault(require("lodash/fp/prop"));

var _last2 = _interopRequireDefault(require("lodash/fp/last"));

var _map2 = _interopRequireDefault(require("lodash/fp/map"));

var _flow2 = _interopRequireDefault(require("lodash/fp/flow"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __spreadArray = void 0 && (void 0).__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];

  return to;
};

var features = [];

var setFeatures = function (newFeatures) {
  features = newFeatures;
};

exports.setFeatures = setFeatures;

var getSelectedFeatures = function (key, items, previous) {
  if (items === void 0) {
    items = features;
  }

  if (previous === void 0) {
    previous = [];
  }

  for (var index = 0; index < items.length; index += 1) {
    var feature = items[index];

    if (feature.key === key) {
      return __spreadArray(__spreadArray([], previous), [feature]);
    }

    if (feature.items) {
      var result = getSelectedFeatures(key, feature.items, __spreadArray(__spreadArray([], previous), [feature]));

      if (result) {
        return result;
      }
    }
  }

  return null;
};

exports.getSelectedFeatures = getSelectedFeatures;

var getFeatureBy = function (attribute) {
  return function (key) {
    var selectedFeatures = getSelectedFeatures(key);

    if (attribute === 'link') {
      return (0, _flow2.default)((0, _map2.default)((0, _prop2.default)('link')), (0, _join2.default)('/'))(selectedFeatures);
    }

    return (0, _flow2.default)(_last2.default, (0, _prop2.default)(attribute))(selectedFeatures);
  };
};

exports.getFeatureBy = getFeatureBy;